import * as yup from 'yup'

const PASSWORD_MIN_LENGTH = 'Password must be at least 6 characters.'
const PASSWORD_MATCH = 'Passwords must match.'
const REQUIRED_FIELD_MSG = 'This field is required.'

export enum FIELDS {
  PASSWORD = 'password',
  REPEAT_PASSWORD = 'repeatPassword',
}

export const schema = yup.object({
  [FIELDS.PASSWORD]: yup.string().trim().required(REQUIRED_FIELD_MSG).min(6, PASSWORD_MIN_LENGTH),
  [FIELDS.REPEAT_PASSWORD]: yup
    .string()
    .trim()
    .required(REQUIRED_FIELD_MSG)
    .oneOf([yup.ref(FIELDS.PASSWORD)], PASSWORD_MATCH),
})
